import { useMemo } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Close";
import { FormTextFieldProps } from "@/app/interfaces/props/FormTextFieldProps";

const FormTextField = ({
  name,
  value,
  onChange,
  clearable = false,
  startAdornment,
  endAdornment,
  InputProps,
  ...rest
}: FormTextFieldProps) => {
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    onChange(e.target.value);
  };

  const handleClear = () => {
    onChange("");
  };

  const combinedInputProps = useMemo(
    () => ({
      ...InputProps,
      startAdornment: startAdornment ? (
        <InputAdornment position="start">{startAdornment}</InputAdornment>
      ) : (
        InputProps?.startAdornment
      ),
      endAdornment: (
        <>
          {clearable && value ? (
            <InputAdornment position="end">
              <IconButton
                aria-label={`clear-${name}`}
                edge="end"
                onClick={handleClear}
                size="small"
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null}
          {endAdornment ? (
            <InputAdornment position="end">{endAdornment}</InputAdornment>
          ) : (
            InputProps?.endAdornment
          )}
        </>
      ),
    }),
    [InputProps, clearable, value, endAdornment, startAdornment, name]
  );

  return (
    <TextField
      {...rest}
      name={name}
      value={value}
      onChange={handleChange}
      InputProps={combinedInputProps}
      size="small"
    />
  );
}

export default FormTextField;
